
//stolen from https://codepen.io/jasonleow/pen/jOVaeXd and adjusted
//BUG: does not work with wrapping text

import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { getPagePosition } from '../../util';
import { InsertSuggestionEvent } from './textsuggest.model';

@Component({
  name: 'TextSuggest',
})
export default class TextSuggest extends Vue {
  //porps
  @Prop({ required: true })
  readonly textBoxId!: string;
  @Prop({ required: true })
  readonly suggestions!: string[];
  @Prop({ default: '@' })
  readonly trigger!: string;
  @Prop({ default: false })
  readonly showAlways!: boolean;

  //runtime
  search: string = '';
  selectedIndex: number = -1;
  prefixTriggered: boolean = false;
  prefix: string = '';
  focused: boolean = false;

  //style
  spanStyle = {};
  xytop: number = 0;
  xyleft: number = 0;

  //elements
  textBox!: HTMLTextAreaElement | HTMLInputElement;
  usernameList!: HTMLElement;
  output!: HTMLElement;

  //textbox listeners
  textboxListeners: any = {
    'keyup': this.updatePosition,
    'mouseup': this.updatePosition,
    'scroll': this.updatePosition,

    'keydown': this.onKeyDown,
    'input': (event) => {
      if (event.target.composing) {
        return;
      }
      this.search = event.target.value;
      this.searchWatcher(this.search);
    },
    'focus': this.checkFocused,
    'blur': () => setTimeout(this.checkFocused, 150), //timeout needed, otherwise suggested item cannot be clicked
    'click': () => this.$nextTick(this.onInput), //clicking may change the carret positiion
  };

  mounted(): void {
    this.textBox = this.$el.parentElement!.querySelector('#' + this.textBoxId) as any;
    this.usernameList = this.$refs.usernamesList as any;
    this.output = this.$refs.output as any;
    // this.xy = this.$refs.xy as any;

    // document.addEventListener("click", this.handleClickOutside);
    for (let event in this.textboxListeners) {
      this.textBox.addEventListener(event, this.textboxListeners[event]);
    }
    this.textBox.addEventListener('keydown', this.preventCursor);

    this.search = this.textBox.value;

    const tbStyle = window.getComputedStyle(this.textBox, null);
    for (let prop of ['line-height', 'padding', 'margin', 'font', 'font-size', 'font-stretch', 'font-family', 'width']) {
      this.spanStyle[prop] = tbStyle[prop];
    }

    this.checkFocused();
  }

  destroyed(): void {
    // document.removeEventListener("click", this.handleClickOutside);
    for (let event in this.textboxListeners) {
      this.textBox.removeEventListener(event, this.textboxListeners[event]);
    }
    this.textBox.removeEventListener('keydown', this.preventCursor);
  }

  //getter
  get shown(): boolean {
    if (!this.focused) {
      return false;
    }
    return (this.showAlways || this.prefixTriggered) && this.shownSuggestions.length > 0;
  }

  get shownSuggestions(): string[] {
    let lprefix = this.prefix.toLowerCase();
    let sug = !lprefix.length
        ? this.suggestions
        : this.suggestions.filter(s => s.toLowerCase().startsWith(lprefix));
    if (this.selectedIndex > sug.length) {
      this.selectedIndex = sug.length - 1;
    }
    return sug;
  }

  //watchers
  @Watch('search', { deep: true })
  searchWatcher(value: string): void {
    this.textBox.value = value;
    this.search = value;
    this.onInput();
    this.selectedIndex = -1;
  }

  //listeners
  onInput(): void {
    let keystrokeTriggered = true;

    const positionIndex = this.textBox.selectionStart;
    const textBeforeCaret = this.textBox.value.slice(0, positionIndex ?? 0);
    const tokens = textBeforeCaret.split(/\s/);
    const lastToken = tokens[tokens.length - 1];
    const triggerIdx = textBeforeCaret.endsWith(lastToken) ? textBeforeCaret.length - lastToken.length : -1;
    if (this.trigger.length) {
      let maybeTrigger = textBeforeCaret.slice(triggerIdx, triggerIdx + this.trigger.length);
      keystrokeTriggered = maybeTrigger === this.trigger;
    }

    this.prefixTriggered = keystrokeTriggered;
    if (!keystrokeTriggered) {
      this.prefix = '';
    } else {
      this.prefix = textBeforeCaret.slice(triggerIdx + this.trigger.length);
    }

    this.$nextTick(() => this.updatePosition()); //needs delay because of search variable needs update via reactive
  }

  listenEnter(): void {
    if (this.shown) {
      return this.onEnter();
    }
  }

  onArrowDown(): void {
    if (this.selectedIndex < this.shownSuggestions.length - 1) {
      this.selectedIndex = this.selectedIndex + 1;
    } else {
      this.selectedIndex = 0;
    }
    this.$nextTick(() => this.usernameList.children[this.selectedIndex].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' }));
  }

  onArrowUp(): void {
    if (this.selectedIndex >= 1) {
      this.selectedIndex = this.selectedIndex - 1;
    } else {
      this.selectedIndex = this.shownSuggestions.length - 1;
    }
    this.$nextTick(() => this.usernameList.children[this.selectedIndex].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' }));
  }

  onEnter(): void {
    if (this.selectedIndex < 0 || this.selectedIndex >= this.shownSuggestions.length) {
      return;
    }
    this.insertSuggestion(this.shownSuggestions[this.selectedIndex]);
    this.textBox.blur();
    setTimeout(() => {
      // this.closeTooltip();
      this.textBox.focus();
    }, 10);
  }

  onKeyDown(event: KeyboardEvent): void {
    if (this.trigger === event.key) {
      // this.showTooltip();
    } else if ('Escape' === event.key && this.shown && !this.showAlways) {
      // this.closeTooltip();
    } else if ('Tab' === event.key && this.shown) {
      event.stopPropagation();
      this.onArrowDown();
    } else if ('ArrowDown' === event.key && this.shown) {
      this.onArrowDown();
    } else if ('ArrowUp' === event.key && this.shown) {
      this.onArrowUp();
    } else if ('ArrowLeft' === event.key || 'ArrowRight' === event.key) {
      setTimeout(() => this.onInput(), 50);
    } else if (' ' === event.key && event.ctrlKey) {
      setTimeout(() => this.onInput(), 50);
    } else if ('Enter' === event.key) {
      this.listenEnter();
    }
  }

  //logic
  updatePosition(): void {
    const output = this.output.firstChild! as HTMLElement;

    let text = this.textBox.value.substr(0, this.textBox.selectionStart ?? 0);
    let endIndex;
    if (this.trigger.length) {
      endIndex = text.lastIndexOf(this.trigger);
      while (endIndex > 0 && text.substr(endIndex - this.trigger.length, this.trigger.length).trim().length > 0) {
        text = text.substr(0, text.length - this.trigger.length);
        endIndex = text.lastIndexOf(this.trigger);
      }
      endIndex = endIndex < 0 ? text.length : endIndex + this.trigger.length;
    } else {
      endIndex = text.lastIndexOf(' ');
      if (endIndex > 0) {
        endIndex += 1;
      }
    }
    output.innerHTML = this.textBox.value.substr(0, endIndex).replace(/\n$/, '\n\u0001').replace(/ /gm, '&nbsp;');

    const rects = output.getClientRects();
    const lastRect = rects[rects.length - 1];
    if (!lastRect)
      return;
    let tbStyle = window.getComputedStyle(this.textBox);
    let tbpos = getPagePosition(this.textBox);
    let tbposparent = getPagePosition(this.textBox.parentElement!);
    const top = 0
            + (lastRect.top - output.getBoundingClientRect().top)
            - this.textBox.scrollTop
            - this.textBox.clientHeight
        //maybe this is need? or not? idk
        // - parseInt(tbStyle['padding-top'])
        // + parseInt(tbStyle['padding-bottom'])
        // - parseInt(tbStyle['border-top'])
    ;
    const left = tbpos.x - tbposparent.x
        - this.textBox.scrollLeft
        + lastRect.width
        - parseInt(tbStyle['padding-left']) * (rects.length > 1 ? 0 : 1) //element.getClientRects() is weird
        - parseInt(tbStyle['border-left']);
    this.xytop = top;
    this.xyleft = left;
  }

  preventCursor(e): void {
    if (!this.shown) {
      return;
    }
    if (e.keyCode == 38 || e.keyCode == 40 || e.keyCode == 13 || e.keyCode == 9) {
      e.preventDefault();
    } else if (e.key === 'Arrow-Up' ||
        e.key === 'Arrow-Down' ||
        e.key === 'Enter' ||
        e.key === 'Tab') {
      e.preventDefault();
    }
  }

  checkFocused(): void {
    this.focused = this.textBox === document.activeElement;
  }

  //insert suggestions
  setResult(result): void {
    this.insertSuggestion(result);
    this.textBox.focus();
  }

  insertSuggestion(value: string) {
    let event = new InsertSuggestionEvent(value);
    this.$emit('insertsuggestion', event);
    if (event.defaultPrevented) {
      this.onInput();
      this.selectedIndex = -1;
      return;
    }

    let text = this.textBox.value;
    let start = 0;
    let end = (this.textBox.selectionStart || 1);

    //find start trigger
    for (let i = end - 1 || 0; i >= 0; i--) {
      if (text.substr(i, 1) === this.trigger) {
        if (i === 0 || text.substr(i - 1, 1).trim().length === 0) {
          start = i + 1;
          break;
        }
      }
    }
    text = text.substr(0, start) + value + ' ' + text.substr(end);
    this.textBox.value = text;
    this.textBox.selectionStart = this.textBox.selectionEnd = start + value.length + 1; //+1 for space behind inserted suggestion

    //manually fire change event
    this.onInput();
    this.selectedIndex = -1;
    // var evt = document.createEvent("HTMLEvents");
    // evt.initEvent("input", false, true);
    // this.textBox.dispatchEvent(evt);
  }
}
